export function getAddressPickerLabels(): { [key: string]: string } {
  if (![30, 31, 92].includes(global.currentUser.tenant.id)) {
    return {}
  }
  return {
    name1: i18n.t('company', 'Firma'),
    name2: i18n.t('contact_partner', 'Ansprechpartner'),
    name3: i18n.t('address_addition', 'Adresszusatz'),
  }
}
